import { Application, Assets, Container } from 'pixi.js';
import AppModel from "../models/AppModel.ts";
import Menu from "../sections/Menu.ts";
import { AssessmentData } from '../models/AssessmentData.ts';
import Assessment from '../sections/Assessment.ts';
import { FontsBundle } from '../utils/RhFontsUtil.ts';
import SoundManager from '../managers/SoundManager.ts';
import Complete from '../sections/Complete.ts';

export default class ScreenerController
{
    private ROOT_ASSETS_PATH = "/assets";

    private app: Application;
    private soundManager: SoundManager;
    private assessment: Assessment;
    private menu:Menu;
    private model: AppModel;
    private container: Container;
    private data: AssessmentData;

    private userId: Number = 0;

    constructor()
    {
        this.model = AppModel.getInstance();
        this.soundManager = SoundManager.getInstance();
        this.createApp().then(() => {
            this.preloadAssets().then(() => {
                this.createContainer();
                this.createMenu();
            });
        });
    }

    private assessmentComplete = (): void => {
        this.container.removeChildren();
        this.container.addChild(new Complete());
    }

    private async createApp(): Promise<void> {
        const pixiAppConfig = {
            antialias: true,
            background: "#000000",
            width: 1366,
            height: 768,
            canvas: document.getElementById('pixi-canvas') as HTMLCanvasElement,
            resolution: window.devicePixelRatio || 1,
            autoDensity: true,
        };
        this.app = new Application();
        this.app.stage.label = "Screener";
        await this.app.init(pixiAppConfig);
        this.model.app = this.app;
    }

    private createAssessment(): void {
        this.assessment = new Assessment(this.data.sections, this.assessmentComplete);
        this.container.addChild(this.assessment);
    }

    private createContainer(): void {
        this.container = new Container();
        this.app.stage.addChild(this.container);
    }

    private createMenu(): void {
        this.menu = new Menu(this.startAssessment);
        this.container.addChild(this.menu);
    }

    private startAssessment = (userId: number): void => {
        this.userId = userId;
        this.model.userId = userId;
        this.container.removeChild(this.menu);
        this.menu = null;

        this.getAssessmentData();
    }

    private getAssessmentData(): void {
        fetch(`/Speech/getAssessmentData?userId=${this.userId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error getting assessment data: ${response.status}`)
                }
                return response.json();
            }).then(data => {
                if (data.data.isComplete) {
                    this.assessmentComplete();
                } else {
                    this.data = data.data;
                    this.createAssessment();
                }
            }).catch(e => {
                console.error(e);
                debugger;
            });
    }

    private onLoadProgress = (progress: Number): void => {
        console.log("onLoadProgress: " + progress + "%");
    }

    private async preloadAssets(): Promise<void> {
        const test: any = { ...FontsBundle };
        const bundle = {
            ...FontsBundle,
            startBtn: {
                alias: "startBtn",
                src: `${this.ROOT_ASSETS_PATH}/start-btn.png`
            },
            continueBtn: {
                alias: "continueBtn",
                src: `${this.ROOT_ASSETS_PATH}/cont-btn.png`
            }
        };

        await Assets.init();
        Assets.addBundle("screener", bundle);
        this.model.assets = await Assets.loadBundle('screener', this.onLoadProgress);
        return Promise.resolve();
    }
}